export default "__VITE_ASSET__CCQGkzbm__"